<template>
  <div class="store">
    <div class="front">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0"  @click="delCmp">删除</div>
        </div>
        
      </div>
    </div>
    <store :tmpType="tmpType"/>
  </div>
</template>

<script>
import store from '@/pages/activity-home/components/store'
export default {
  components: {
    store
  },
  props: {
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    tmpType: Number,
  },
  methods: {
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  }
}
</script>

<style lang="stylus" scoped>
.store {
  .front {
    position: relative;
    .head {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
}
</style>